module.exports = __webpack_public_path__ + "static/media/img_portfolio.b2c93250.png";